import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useBranch } from '../contexts/BranchContext'
import Sidebar from './Sidebar'
import Header from './Header'
import MobileMenu from './MobileMenu'
import ThinkinCodeFooter from './ThinkinCodeFooter'

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const { role } = useAuth()
  const { currentBranch } = useBranch()

  return (
    <div className="min-h-screen bg-background">
      {/* Mobile menu */}
      <MobileMenu open={sidebarOpen} setOpen={setSidebarOpen} />

      {/* Desktop sidebar */}
      <div className="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-64 lg:flex-col">
        <Sidebar />
      </div>

      {/* Main content */}
      <div className="flex min-h-screen flex-1 flex-col lg:pl-64">
        <Header 
          sidebarOpen={sidebarOpen} 
          setSidebarOpen={setSidebarOpen}
          currentBranch={currentBranch}
          userRole={role}
        />

        <main className="flex flex-1 flex-col bg-gradient-to-b from-background via-background to-muted/25">
          <div className="flex-1 py-6">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
              <Outlet />
            </div>
          </div>
          <ThinkinCodeFooter />
        </main>
      </div>
    </div>
  )
} 